import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { forwardRef, useContext } from 'react';
import cx from 'classnames';
import { prefix } from '../../../tools/settings';
import { TakeoverContext } from '../Takeover';
import { Styled } from './Body.styles';
import { jsx as _jsx } from "react/jsx-runtime";

var useTakeoverContext = function useTakeoverContext() {
  return useContext(TakeoverContext);
};

var Body = forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      customClassName = _ref.className,
      id = _ref.id;

  var _useTakeoverContext = useTakeoverContext(),
      isFullWidth = _useTakeoverContext.isFullWidth;

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-takeover__body"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(Styled.Main, {
    ref: ref,
    id: id,
    className: className,
    children: _jsx(Styled.Body, {
      isFullWidth: isFullWidth,
      children: children
    })
  });
});
export default Body;